/**
 * A dónde lleva la entrada de Zindra Work desde la app móvil.
 *
 * **Solo a Zindra Work, y siempre dentro de zindra.com.** La app pide la
 * pantalla con `?ir=`; si esto aceptara cualquier cosa, la entrada serviría
 * para mandar a alguien, ya con la sesión puesta, a donde quisiera quien
 * construyera el enlace (una redirección abierta). Así que se admite solo una
 * ruta propia de las cuatro zonas, con su consulta, y todo lo demás cae en el
 * chat. `app=work` se pone siempre: es lo que hace que la web se vea como
 * Zindra Work y no como el panel.
 */

export const COOKIE_MOVIL = "zindra_movil"

const ZONAS = ["/chat", "/chat/agentes", "/proyectos", "/calendario"]

export function destinoDeLaEntrada(ir: string | null | undefined): string {
  const porDefecto = "/chat?app=work"
  if (!ir || !ir.startsWith("/") || ir.startsWith("//") || ir.includes("\\")) return porDefecto

  let url: URL
  try {
    url = new URL(ir, "https://zindra.com")
  } catch {
    return porDefecto
  }
  if (url.origin !== "https://zindra.com" || !ZONAS.includes(url.pathname)) return porDefecto

  url.searchParams.set("app", "work")
  return `${url.pathname}?${url.searchParams.toString()}`
}
